// extracted by mini-css-extract-plugin
export default {"container":"Main_container__Bgy4k"};